import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {FormDataUpload, NestApiProvider} from "../nest-api";


@Injectable()
export class StorageProvider {

  private _service: string = 'attendance';
  private _model: string = 'storage';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public upload(file: File, fileName: string): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'upload';
    const _params: FormDataUpload[] = [];
    _params.push({name: 'file', value: file,fileName});
    const _urlParams: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestUpload(_method, _url, _params);
  }

  public getURLUpload(): string {
    const _method: string = 'POST';
    const _func: string = 'upload';
    const _urlParams: any = {};
    return this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/storage/storage.ts